import React, { useState } from "react";
import { FiCopy } from "react-icons/fi";
import classnames from "classnames";

// utils
import { Access } from "common";

// components
import { Modal } from "components";

// styles
import "./styles.scss";

function UserInfoModal({ user, isOpen, onRequestClose }) {
  const [isCopy, setIsCopy] = useState(false);
  const token = localStorage.getItem("auth_token");

  const userInfo = {
    name: user.data.attributes.name,
    email: user.data.attributes.email,
  };

  function copyTokenToClipboard() {
    setIsCopy(true);
    navigator.clipboard.writeText(token);
    setTimeout(() => setIsCopy(false), 3000);
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <div className="userInfo">
        <h2>Dados do usuário</h2>
        <hr />

        <div>
          <b>nome: </b> {userInfo.name}
        </div>

        <div>
          <b>e-mail</b>: {userInfo.email}
        </div>

        {Access.hasPermissions("durga-application") ? (
          <div>
            <b>Chave Durga:</b>
            <span className="secret">{token}</span>
            <button
              className={classnames({
                copy: isCopy,
              })}
              type="button"
              onClick={copyTokenToClipboard}
            >
              <FiCopy />
            </button>
          </div>
        ) : null}
      </div>
    </Modal>
  );
}

export { UserInfoModal };
